import PostForm from '../../components/shared/PostForm';
import * as Yup from 'yup';
import MainLayout from '../../components/layouts/MainLayout';
import Breadcrumb from '../../components/shared/Breadcrumbs';
import Modal from '../../components/ui/Modal';
import useModal from '../../hooks/useModal'
import React, { useState, useEffect } from 'react';
import  { useFetchJobPost } from '../../hooks/useFetchData';
import { useLocation } from 'react-router-dom';



const JobPostForm = () => {
  const { data: job_post, loading, error } =  useFetchJobPost(); 
  const { isOpen, openModal, closeModal } = useModal();
  const [currentPage, setCurrentPage] = useState("");
  const [initialValues, setInitialValues] = useState(null);
  const location = useLocation(); 
  const params = new URLSearchParams(location.search);
  const id = params.get("id");
  const backUrl = process.env.REACT_APP_API_URL;


  useEffect(() => {
    if (id) {
      const customizedValues = {
        title: job_post.title || "",
        address: job_post.address || "",
        images: job_post.images || [],
        wages: job_post.wages || "",
        wages2: job_post.wages2 || "",
        shopname: job_post.shopname || "",
        job_cat: job_post.job_cat != null ? job_post.job_cat.toString() : "",
        english: job_post.english != null ? job_post.english.toString() : "",
        content: job_post.content || "",
        toll: job_post.toll !== undefined ? job_post.toll : false, // 'toll' が undefined の場合、false をデフォルトに
      };
      setInitialValues(customizedValues);
      console.log(customizedValues); // デバッグ用ログ
    }
  }, [job_post]);

  if (loading) return <p>Loading...</p>;
  if (error) {
    console.error('Error fetching job post data:', error);
  }
  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "求人情報投稿一覧", path: "/sharehouse" },
    { label: "投稿FORM", path: "/sharehouse/:postId" },
  ];
  const formConfig={
    fields: [
      { name: 'title', type: 'text', label: 'Title', placeholder: 'タイトルを入力してください', validation: Yup.string().required('必須項目です') },
      { name: 'shopname', type: 'text', label: '店名・会社名', placeholder: '店名・会社名を入力してください', validation: Yup.string().required('必須項目です') },
      { name: 'address', type: 'text', label: 'Address', placeholder: '住所を入力してください', validation: Yup.string().required('必須項目です'), description: '探しやすさ向上のためストリートまでの入力をお願い致します。' },
      { name: 'images', type: 'image', label: '画像', description: '後からの画像の変更はできません'},
      { name: 'wages', type: 'number', label: '時給', placeholder: '時給を入力してください', validation: Yup.number().typeError('数字を入力してください'), b_uint: '$' },
      { name: 'wages2', type: 'number', label: '週末時給', placeholder: '時給を入力してください', validation: Yup.number().typeError('数字を入力してください'), b_uint: '$' },
      { name: 'english', type: 'radio', label: '必要英語力', category: 'english', validation: Yup.string().required('必須項目です') },
      { name: 'job_cat', type: 'radio', label: 'カテゴリー', category: 'job_cat', validation: Yup.string().required('必須項目です') },
      { name: 'content', type: 'textbox', label: 'コンテンツ' },
      { name: 'toll', type: 'boolean', label: '有力枠に掲載する', initialValue: "False", description: 'チェックの入れられた投稿はお支払いの確認後上部表示、GC Koalaのインスタグラムでのご紹介をさせていただきます。詳しくは投稿完了時のメールをご覧ください。'},
    ],
  }
  let type
  let apiUrl
  if(id){
    type = "editform";
    apiUrl = {submit: `${backUrl}api/post_get/?type=job&id=${job_post.id}`};
  }else{
    type = "postform";
    apiUrl ={submit: `${backUrl}/api/post_get/?type=job`};
  }

  return (
    <>
    <MainLayout>
    <Breadcrumb items={breadcrumbs} />
    <PostForm
      title={'Job Offer'}
      formConfig={formConfig}
      type={type}
      apiUrl={apiUrl}
      openModal={openModal}
      setCurrentPage={setCurrentPage}
      initialValues={initialValues || formConfig.fields.reduce((acc, field) => {
        acc[field.name] = field.initialValue || (field.type === 'checkbox' ? [] : '');
        return acc;
      }, {})}
    />
    </MainLayout>
    <Modal 
    isOpen={isOpen} 
    closeModal={closeModal} 
    currentPage={currentPage} 
    setCurrentPage={setCurrentPage} 
    className="login"
    >
    </Modal>
    </>
  );
};
export default JobPostForm;